import { useMemo } from 'react';

import { SearchDomain } from '../../types/SearchDomain';
import { useSearchConfigMapper } from '../useSearchConfigMapper/useSearchConfigMapper';
import { useSearchRouter } from '../useSearchRouter/useSearchRouter';

interface UseSearchURLOptions {
  query?: string | null;
  domain?: SearchDomain;
}

/**
 * Custom hook to generate search URLs using the react-instantsearch router
 * @param options - Configuration options
 * @returns Object containing the search string and navigation utilities
 */
export const useSearchURL = ({ query, domain = SearchDomain.PURCHASE_ORDER }: UseSearchURLOptions) => {
  const configMapper = useSearchConfigMapper();
  const { routing } = useSearchRouter(configMapper);

  const searchParams = useMemo(() => {
    if (!query?.trim()) {
      return '';
    }

    try {
      const urlString = routing.router?.createURL({ query });
      if (urlString) {
        const url = new URL(urlString);
        return url.search;
      }
    } catch (error) {
      console.warn('Failed to create search URL:', error);
    }

    return '';
  }, [query, routing.router]);

  return {
    searchParams,
    hasSearch: Boolean(searchParams),
    domain,
  };
};
